"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connectivity$ = exports.Connectivity$outboundSchema = exports.Connectivity$inboundSchema = void 0;
exports.connectivityToJSON = connectivityToJSON;
exports.connectivityFromJSON = connectivityFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const mobileservicecoverageitem_js_1 = require("./mobileservicecoverageitem.js");
const predictedbroadbandspeeds_js_1 = require("./predictedbroadbandspeeds.js");
/** @internal */
exports.Connectivity$inboundSchema = z.object({
    broadband_availability: z.nullable(z.array(predictedbroadbandspeeds_js_1.PredictedBroadbandSpeeds$inboundSchema)),
    mobile_service_coverage: z.nullable(z.array(mobileservicecoverageitem_js_1.MobileServiceCoverageItem$inboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "broadband_availability": "broadbandAvailability",
        "mobile_service_coverage": "mobileServiceCoverage",
    });
});
/** @internal */
exports.Connectivity$outboundSchema = z.object({
    broadbandAvailability: z.nullable(z.array(predictedbroadbandspeeds_js_1.PredictedBroadbandSpeeds$outboundSchema)),
    mobileServiceCoverage: z.nullable(z.array(mobileservicecoverageitem_js_1.MobileServiceCoverageItem$outboundSchema)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        broadbandAvailability: "broadband_availability",
        mobileServiceCoverage: "mobile_service_coverage",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Connectivity$;
(function (Connectivity$) {
    /** @deprecated use `Connectivity$inboundSchema` instead. */
    Connectivity$.inboundSchema = exports.Connectivity$inboundSchema;
    /** @deprecated use `Connectivity$outboundSchema` instead. */
    Connectivity$.outboundSchema = exports.Connectivity$outboundSchema;
})(Connectivity$ || (exports.Connectivity$ = Connectivity$ = {}));
function connectivityToJSON(connectivity) {
    return JSON.stringify(exports.Connectivity$outboundSchema.parse(connectivity));
}
function connectivityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Connectivity$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Connectivity' from JSON`);
}
//# sourceMappingURL=connectivity.js.map